<template lang="pug">
  .container(id="StatusBarDevices-container")
    .item.to-be-updated-counter(id="StatusBarDevices-updatableDesktopsCounter" @click='showUpdatableDesktops()', :title='$t("Updatable screens")', :class="{ 'active': modifications.length > 0 }")
      font-awesome-icon(icon="upload")
      span &nbsp; {{ modifications.length }}
    .item.updating-counter(id="StatusBarDevices-updatingCounter" @click='showOngoingSynchroDesktops()', :title='$t("Content synchronizations in progress")', :class="{ 'active': contentDownloadsInProgress.length > 0 }")
      font-awesome-icon(icon="cloud-download-alt")
      span &nbsp; {{ contentDownloadsInProgress.length }}
    .item.separator
    .item(id="StatusBarDevices-failedRequests" :title='$t("Failed requests")', @click='showFailedRequests',  :class="{ 'active': failedRequests.length > 0 }")
      font-awesome-icon.danger(icon="exclamation-circle")
      span &nbsp; {{ failedRequests.length }}
    .item.separator
    .item.selected-counter(id="StatusBarDevices-selectedDesktopsCounter" @click='showSelectedDesktops()', :title='$t("Selected screens")', :class="{ 'active': desktopsSelectedCounter > 0 }")
      font-awesome-icon(icon="check-square")
      span &nbsp; {{ desktopsSelectedCounter }}
    //- .item.current-synchro-counter(@click='showDevicesInContentSynchro()', :title='$t("devices during synchronization")', :class="{ 'active': desktopsSelectedCounter > 0 }")
    //-   font-awesome-icon(icon="file-video")
    //-   span &nbsp; {{ desktopsSelectedCounter }}
    el-dialog(:visible.sync="selectedDesktopsListVisible", @close='selectedDesktopsListVisible = false', :close-on-click-modal="false")
      SelectedDesktopsList
    el-dialog(
      :visible.sync="updatableDesktopsListVisible",
      @close='updatableDesktopsListVisible = false',
      :close-on-click-modal="false",
      width='80%'
    )
      UpdateContentToStartReportList(v-if='updatableDesktopsListVisible', @finished='updatableDesktopsListVisible = false')
    el-dialog(
      v-if='ongoingSynchroDesktopsListVisible',
      :visible.sync="ongoingSynchroDesktopsListVisible",
      @close='ongoingSynchroDesktopsListVisible = false',
      :close-on-click-modal="false",
      width='80%'
    )
      UpdateContentProgressReportList(v-if='ongoingSynchroDesktopsListVisible', @finished='ongoingSynchroDesktopsListVisible = false', type="inProgress", @stopContentDownload='stopContentDownload')
    el-dialog(:visible.sync="failedRequestsListVisible", @close='closeFailedRequests', :close-on-click-modal="false")
      FailedRequestsList(v-if='failedRequestsListVisible', @close='closeFailedRequests')
</template>

<script>

import Vue from 'vue'
import SelectedDesktopsList from './Device/SelectedDesktopsList'
import textUtils from './Common/textUtils.mixin'
import UpdateContentToStartReportList from './Device/UpdateContentToStartReportList'
import UpdateContentProgressReportList from './Device/UpdateContentProgressReportList'
import FailedRequestsList from './Device/FailedRequestsList'

export default {
  mixins: [ textUtils ],
  components: {
    SelectedDesktopsList,
    UpdateContentToStartReportList,
    UpdateContentProgressReportList,
    FailedRequestsList
  },
  created () {
    this.$store.dispatch('Device/activateWsListener')
    this.$store.dispatch('Request/activateWsListener')
    setInterval(() => {
      if (this.$store.state.User.liveMode.contentPending) return
      this.$store.dispatch('Device/getDeviceDesktopsAffected')
      this.$store.dispatch('Device/getContentDownloads')
    }, 1000 * 60)
  },
  watch: {
    failedRequests (newUnseenList, oldUnseenList) {
      // Our fancy notification.
      if (newUnseenList.length !== oldUnseenList.length && newUnseenList > oldUnseenList) {
        const lastRequest = newUnseenList[newUnseenList.length - 1]
        this.$notify.error({
          title: this.$t('Device reported an Error'),
          message: `${this.getFullDeviceNameByDesktopId(lastRequest.DeviceDesktop)} - ${lastRequest.method}: ${lastRequest.responseRaw.name} / ${lastRequest.responseRaw.message}`
        })
      }
    }
  },
  data () {
    return {
      errors: {
      },
      selectedDesktopsListVisible: false,
      updatableDesktopsListVisible: false,
      ongoingSynchroDesktopsListVisible: false,
      failedRequestsListVisible: false
    }
  },
  methods: {
    showFailedRequests () {
      this.failedRequestsListVisible = true
    },
    closeFailedRequests () {
      this.$store.dispatch('Request/markFailedRequestsAsSeen')
      this.failedRequestsListVisible = false
    },
    showSelectedDesktops () {
      this.selectedDesktopsListVisible = true
    },
    showUpdatableDesktops () {
      if (this.modifications.length === 0) return
      this.updatableDesktopsListVisible = true
    },
    showOngoingSynchroDesktops () {
      if (this.contentDownloadsInProgress.length === 0) return
      this.ongoingSynchroDesktopsListVisible = true
    },
    async stopContentDownload (contentDownload) {
      await Vue.axios
        .delete(`contentdownload/${contentDownload.id}`)
        .then(response => {
          if (this.$store.state.User.liveMode.contentPending) {
            this.$store.dispatch('Device/deleteContentDownload', contentDownload.id)
          }
        })
      if (this.contentDownloadsInProgress.length === 0) this.ongoingSynchroDesktopsListVisible = false
    }
  },
  computed: {
    failedRequests () {
      return this.$store.state.Request.requests_failed_list.filter(fr => !fr.seen)
    },
    contentDownloadsInProgress () {
      return this.$store.state.Device.content_downloads
        .filter(cd => cd.progress < 100)
        // .filter(cd => this.devicesFiltered.includes(cd.ContentDownloadDeviceDesktop.Device))
    },
    desktopsSelectedCounter () {
      return this.$store.state.Device.desktops_selected_right.length
    },
    desktopsUpdatableCounter () {
      return this.$store.state.Device.desktops_affected.length
    },
    modifications () {
      return this.$store.state.Device.desktops_affected
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../theme-m4b/src/common/var.scss";
.container {
  display: flex;
  padding: 5px 20px;
  justify-content: space-between;
  align-items: stretch;
  .item {
    padding: 0px 8px;
    cursor: pointer;
    opacity: 0.3;
    &.active {
      opacity: 1;
    }
    &.separator {
      border-right: $--border-light;
      margin-right: 20px;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatusBarDevices.vue